<template>
  <div>
    <Drawer
      :mask-closable="false"
      :title="title"
      @on-cancel="cancelDetail"
      v-model="isAdd"
      width="50vw"
    >
      <todoHandler
        :processInstanceId="processInstanceId"
        :taskId="taskId"
        @close="cancelDetail"
        v-if="opts.type == 'todo'"
      ></todoHandler>
      <inboxHandler :id="inboxId" @close="cancelDetail" v-if="opts.type == 'inbox'"></inboxHandler>
    </Drawer>
  </div>
</template>
<script>
export default {
  name: 'inBox',
  inject: ['reload'],
  props: {
    opts: {
      required: false
    }
  },
  data () {
    return {
      socket: null,
      isAdd: false,
      taskId: null,
      inboxId: null,
      title: '',
      processInstanceId: null
    }
  },
  watch: {
    opts: {
      immediate: true,
      deep: true,
      handler: function (newValue, oldVale) {
        console.log('newValue', newValue)
        switch (newValue.type) {
          case 'todo':
            this.processInstanceId = newValue.data.processInstanceId
            this.title = newValue.data.name
            this.taskId = newValue.data.id
            this.isAdd = true
            break
          case 'inbox':
            this.title = newValue.data.title
            this.inboxId = newValue.data.id
            this.isAdd = true
            this.initInboxCount()
            break
        }

      }
    }
  },
  methods: {
    cancelDetail: function () {
      this.processInstanceId = ''
      this.inboxId = null
      this.title = ''
      this.taskId = ''
      this.isAdd = false
      this.initTodoCount()
      this.initInboxCount()
      this.$emit('close', this.opts.type)
    },
    initInboxCount: function () {
      let that = this
      this.$axios.post(that.$apis.inboxApi.getCount).then(res => {
        if (res.success) {
          let data = res.result || {}
          this.$store.commit("SET_INBOXCOUNT", data.count || 0)
          this.$store.commit("SET_INBOXLIST", data.inboxList || [])
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("获取站内信失败！")
      })
    },
    initTodoCount: function () {
      let that = this
      this.$axios.post(that.$apis.workflowMgr.myaffairs.todo.getTodoCount).then(res => {
        if (res.success) {
          let data = res.result || {}
          this.$store.commit("SET_TODOCOUNT", data.count || 0)
          this.$store.commit("SET_TODOLIST", data.tasks || [])
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("获取待办记录失败！")
      })
    },
    initWebSocket: function (user) {
      console.log('initWebSocket...')
      this.initInboxCount()
      this.initTodoCount()
      if (typeof (WebSocket) === "undefined") {
        this.$Notice.warning({
          title: '系统信息',
          desc: "您的浏览器不支持socket,请联系管理员"
        })
        console.error("您的浏览器不支持socket,请联系管理员")
      } else {
        // 实例化socket
        var socketUrl = window.location.protocol + '//' + location.host + '/agility/noticer?name=' + user
        socketUrl = socketUrl.replace("https", "wss").replace("http", "ws")
        console.log('socketUrl', socketUrl)
        this.socket = new WebSocket(socketUrl)
        // 监听socket连接
        this.socket.onopen = this.handlerOpen
        // 监听socket错误信息
        this.socket.onerror = this.handlerError
        // 监听socket消息
        this.socket.onmessage = this.getMessage
      }
    },
    reloadSocket: function () {
      this.close()
      this.initWebSocket(this.$store.getters['userInfo/account'])
    },
    handlerOpen: function () {
      console.log('websocket onopen')
    },
    handlerError: function (err) {
      console.error("websocket 连接失败！", err)
    },
    /*接收消息*/
    getMessage: function (msg) {
      let msgObj = JSON.parse(msg.data)
      console.log('getMessage', msgObj)
      let body = JSON.parse(msgObj.body)
      if (body.message) {
        this.$Notice.info({
          top: 60,
          duration: 5,
          title: '系统消息',
          desc: body.message,

        })
      }
      switch (msgObj.cmd) {
        case 'todo':
          this.$store.commit("SET_TODOCOUNT", body.count || 0)
          this.$store.commit("SET_TODOLIST", body.tasks || [])
          if (this.$route.name == 'systemSettingworkflowconfigmyaffairstodo') this.reload()
          break
        case 'inbox':
          this.$store.commit("SET_INBOXCOUNT", body.count || 0)
          this.$store.commit("SET_INBOXLIST", body.inboxList || [])
          if (this.$route.name == 'systemSettinginbox') this.reload()
          break
        case 'offline':
          this.$router.push({ name: 'login' })
          break
      }
    },
    /*发送消息*/
    send: function (msg) {
      console.log("send", msg)
      if (this.socket) this.socket.send(JSON.stringify({ body: msg }))
    },
    /*关闭连接*/
    close: function (e) {
      console.log('断开连接', e)
      // debugger
      if (this.socket) this.socket.close()
    }
  },
  beforeMount () {
    this.initWebSocket(this.$store.getters['userInfo/account'])

  },
  mounted () {
    let _this = this
    this.$bus.$on('reloadSocket', () => {
      _this.reloadSocket()

    })

  },
  beforeDestroy () {
    this.close()
  }
}
</script>
<style scoped>
</style>